export enum AgreementAttribute {
  ACCEPTED_DATE = 'ACCEPTED_DATE',
  AGREEMENT_ID = 'AGREEMENT_ID',
  EDITED_DATE = 'EDITED_DATE',
  IS_ACCEPTED = 'IS_ACCEPTED',
  IS_EDITED = 'IS_EDITED',
  MEMBER_ID = 'MEMBER_ID',
  SENT_DATE = 'SENT_DATE',
}

export enum MemberColumnAttribute {
  ID = 'ID',
  EMAIL = 'EMAIL',
  NAME = 'NAME',
  IS_IMPORTANT = 'IS_IMPORTANT',
  IS_CONTACT = 'IS_CONTACT',
  SOURCE = 'SOURCE',
  CREATED_DATE = 'CREATED_DATE',
  UPDATED_DATE = 'UPDATED_DATE',
}

export enum MemberEdgeAttribute {
  GROUPS = 'GROUPS',
  HIGHLIGHTS = 'HIGHLIGHTS',
  OWNERS = 'OWNERS',
  PROGRAMS_ACCEPTED = 'PROGRAMS_ACCEPTED',
  PROGRAMS_APPLIED = 'PROGRAMS_APPLIED',
  PROGRAMS_INVITED = 'PROGRAMS_INVITED',
  PROGRAMS_REJECTED = 'PROGRAMS_REJECTED',
  TAGS = 'TAGS',
}

export const MEMBER_FIELD_PREFIX = 'MEMBER_FIELD';
export const MEMBER_FIELD_REGEX = `^${MEMBER_FIELD_PREFIX}\\.(\\d+)$`;

export enum PfaOrderAttribute {
  REQUEST_STATUS = 'REQUEST_STATUS',
}

export enum SalesTrackingAttribute {
  TOTAL_CONVERSIONS = 'TOTAL_CONVERSIONS',
  TOTAL_SALES = 'TOTAL_SALES',
  ORDER_VALUE = 'ORDER_VALUE',
  BOOST_REWARD_COUNT = 'BOOST_REWARD_COUNT',
  CONVERSION_DATE = 'CONVERSION_DATE',
  REWARD_TYPE = 'REWARD_TYPE',
}

export enum OrderRequestStatus {
  ACCEPTED = 'ACCEPTED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}

export type MemberAttribute = MemberColumnAttribute | MemberEdgeAttribute | string;

export type IEntityAttribute =
  | AgreementAttribute
  | MemberAttribute
  | PfaOrderAttribute
  | SalesTrackingAttribute;

export const ATTRIBUTE_RELATION_MAP = {
  [MemberEdgeAttribute.GROUPS]: {
    communities: true,
  },
  [MemberEdgeAttribute.HIGHLIGHTS]: {
    highlights: true,
  },
  [MemberEdgeAttribute.OWNERS]: {
    owners: true,
  },
  [MemberEdgeAttribute.PROGRAMS_ACCEPTED]: {
    programMembershipChangeLog: true,
  },
  [MemberEdgeAttribute.PROGRAMS_APPLIED]: {
    programMembershipChangeLog: true,
  },
  [MemberEdgeAttribute.PROGRAMS_INVITED]: {
    programMembershipChangeLog: true,
  },
  [MemberEdgeAttribute.PROGRAMS_REJECTED]: {
    programMembershipChangeLog: true,
  },
  [MemberEdgeAttribute.TAGS]: {
    tags: true,
  },
};
